import { styled } from '@mui/material';

import { Link } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { AddIcon, RobotIcon, UsersIcon } from '@app-velocity/icons';

import { useReportContext } from '../../../../context/useReportContext';
import { ReportPaths } from '../../../../paths/ReportPaths';

const StyledParticipants = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
}));

const StyledTitle = styled('h2')({
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'uppercase',
  margin: 0,
});

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

const StyledLabel = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const StyledLine = styled(Link)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  height: theme.spacing(8),
  '&:link, &:visited, &:hover, &:active': {
    color: '#7a7a7a',
  },
  svg: {
    fill: '#7a7a7a',
  },
}));

const AddParticipantButton = styled(Link)(({ theme }) => ({
  background: 'var(--button-button-primary-color)',
  border: '2px solid var(--button-button-primary-stroke-color)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  '&:hover': {
    background: 'var(--button-button-primary-stroke-color)',
  },
  svg: {
    fill: 'var(--button-button-primary-text-color)',
  },
}));

const StyledValue = styled('span')({
  fontSize: 14,
});

export const Participants = () => {
  const { t } = useI18n();
  const { statistics, config, baseURL } = useReportContext();
  const { simulatedReviews, uniqueHumanTesters } = statistics;

  const { humanParticipantsAllowed, hasAccessToSims } = config;

  return (
    <StyledParticipants>
      <StyledHeader>
        <StyledTitle>{t('prototypes:participants.title')}</StyledTitle>
        {hasAccessToSims ? (
          <AddParticipantButton to={ReportPaths.goToConfidence(baseURL)}>
            <AddIcon />
          </AddParticipantButton>
        ) : null}
      </StyledHeader>

      {humanParticipantsAllowed ? (
        <StyledLine to={ReportPaths.goToHumanParticipants(baseURL)}>
          <StyledLabel>
            <UsersIcon />
            {t('prototypes:participants.human')}
          </StyledLabel>
          <StyledValue>{uniqueHumanTesters}</StyledValue>
        </StyledLine>
      ) : null}

      <StyledLine to={ReportPaths.simulatedParticipants}>
        <StyledLabel>
          <RobotIcon />
          {t('prototypes:participants.simulated')}
        </StyledLabel>
        <StyledValue>
          {simulatedReviews.succeded + simulatedReviews.failed}
        </StyledValue>
      </StyledLine>
    </StyledParticipants>
  );
};
